import { Navigate } from "react-router-dom";
import ResellerAgentDashboard from "../pages/resellerAgentDashboard/resellerAgentDashboard";
import CostBreakdown from "../pages/costBreakdown/costBreakdown";
import CreditCardForm from "../pages/creditCardForm/creditCardForm";
import Error from "../pages/errorPage/errorPage";
import CreditCardSuccess from "../pages/creditCardSuccess/creditCardSuccess";
import Loader from "../components/loader/loader";
import HealthCheckGuard from "../components/heathCheckGuard/heathCheckGuard";

const RedirectHomeElement = () => <Navigate to={"/reseller-agent-dashboard"} />;
const RedirectErrorElement = () => <Navigate to={"/page-not-found"} />;

//Add the authenticated pages
export const navItemsPaths = [
  {
    path: "/",
    element: (
      <HealthCheckGuard>
        <RedirectHomeElement />
      </HealthCheckGuard>
    ),
    isPrivateRoute: true,
  },
  {
    path: `/reseller-agent-dashboard`,
    element: (
      <HealthCheckGuard>
        <ResellerAgentDashboard />
      </HealthCheckGuard>
    ),
    isPrivateRoute: true,
  },
  {
    path: `/cost-breakdown`,
    element: (
      <HealthCheckGuard>
        <CostBreakdown />
      </HealthCheckGuard>
    ),
    isPrivateRoute: true,
  },
  {
    path: `/*`,
    element: (
      <HealthCheckGuard>
        <RedirectErrorElement />
      </HealthCheckGuard>
    ),
    isPrivateRoute: true,
  },
];

//Add the unauthenticated pages
export const authItemsPaths = [
  {
    path: `/*`,
    element: <Loader loading={true} />,
    isPrivateRoute: true,
  },
  {
    path: "/page-not-found",
    element: <Error />,
    isPrivateRoute: false,
  },
  {
    path: "/page-under-construction",
    element: <Error />,
    isPrivateRoute: false,
  },
  {
    path: `/credit-card-form`,
    element: (
      <HealthCheckGuard>
        <CreditCardForm />
      </HealthCheckGuard>
    ),
    isPrivateRoute: false,
  },
  {
    path: `/credit-card-submit-success`,
    element: (
      <HealthCheckGuard>
        <CreditCardSuccess />
      </HealthCheckGuard>
    ),
    isPrivateRoute: false,
  },
];
